// eslint-disable-next-line no-shadow
export enum PaymentType {
    Payment = 'payment',
    Tip = 'tip',
    TrailerCancellation = 'trailer cancellation',
    DriverCancellation = 'driver cancellation'
}
